var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading === true)?_c('v-progress-circular',{staticClass:"mx-2",attrs:{"size":_vm.loadingSize,"width":_vm.loadingWidth,"indeterminate":""}}):_c('span',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }